import React, { useState } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";

const TauriBreadCrumbDropdown = ({
    items,
    onSelect,
    selectedItem,
    id,
    variant,
    className,
    menuClassName,
    toggleClassName,
    placeholder,
    showCheckbox
}) => {
    
    const [selectedItems, setSelectedItems] = useState(showCheckbox ? ["ALL"] : []);


    const handleSelect = (value) => {
        let updatedSelection = [...selectedItems];
    
        if (value === "ALL") {
            updatedSelection = selectedItems.includes("ALL") ? [] : updatedSelection = ["ALL"];
        } else {
            if (selectedItems.includes(value)) {
                updatedSelection = selectedItems.filter((v) => v !== value); // Unselect item
            } else {
                updatedSelection = [...selectedItems, value]; // Select item
            }
    
            // Ensure "ALL" is always unchecked if any other item is selected
            updatedSelection = updatedSelection.filter(item => item !== "ALL");
        }
    
        // Convert the selection to a comma-separated string
        const selectionString = updatedSelection.join(",");
        
        setSelectedItems(updatedSelection);
        onSelect(showCheckbox ? selectionString : value);
    };
    


    return (
        <Dropdown className={className}>
            <Dropdown.Toggle variant={variant} id={id} className={toggleClassName}>
                {selectedItem || placeholder}
            </Dropdown.Toggle>
            <Dropdown.Menu className={menuClassName}>
                {items.map((item, index) => (
                    <Dropdown.Item key={index}
                        onClick={(e) => {
                            if (!showCheckbox) {
                                handleSelect(item.value);
                            } else {
                                e.preventDefault(); // Keep dropdown open when clicking checkboxes
                            }
                        }}>
                        {showCheckbox && (
                            <Form.Check
                                type="checkbox"
                                className="me-2"
                                checked={selectedItems.includes(item.value)}
                                onChange={() => handleSelect(item.value)}
                                onClick={(e) => e.stopPropagation()}
                            />
                        )}
                        {item.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

TauriBreadCrumbDropdown.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
        })
    ).isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.string,
    variant: PropTypes.string,
    className: PropTypes.string,
    menuClassName: PropTypes.string,
    toggleClassName: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    showCheckbox: PropTypes.bool,
};

TauriBreadCrumbDropdown.defaultProps = {
    variant: "secondary",
    className: "",
    id: "",
    selectedItem: "",
    menuClassName: "",
    toggleClassName: "",
    placeholder: "---Select---",
    showCheckbox: false,
};

export default TauriBreadCrumbDropdown;
